export default __webpack_public_path__ + "static/media/regulatory--height-limit--g1.98af1a7f.png";